export const translations = {
    fr: {
        nav_chroniques: 'Chroniques',
        nav_blog: 'blog.ie',
        nav_admin: 'Admin',
        nav_home: 'Accueil',
        search_placeholder: 'Rechercher un créateur...',
        no_creators_found: 'Aucun créateur trouvé.',
        campaign_label: 'Campagne',
        recent_albums: 'Récemment publié',
        chroniques_title: 'Chroniques',
        chroniques_subtitle: 'Les albums, classés par année.',
        help_link: 'Aide',
    },
    en: {
        nav_chroniques: 'Chronicles',
        nav_blog: 'blog.ie',
        nav_admin: 'Admin',
        nav_home: 'Home',
        search_placeholder: 'Search creators...',
        no_creators_found: 'No creators found.',
        campaign_label: 'Campaign',
        recent_albums: 'Recently published',
        chroniques_title: 'Chronicles',
        chroniques_subtitle: 'Albums, sorted by year.',
        help_link: 'Help',
    },
    vi: {
        nav_chroniques: 'Biên niên sử',
        nav_blog: 'blog.ie',
        nav_admin: 'Quản trị',
        nav_home: 'Trang chủ',
        search_placeholder: 'Tìm người sáng tạo...',
        no_creators_found: 'Không tìm thấy.',
        campaign_label: 'Chiến dịch',
        recent_albums: 'Mới đăng gần đây',
        chroniques_title: 'Biên niên sử',
        chroniques_subtitle: 'Album, sắp xếp theo năm.',
        help_link: 'Trợ giúp',
    },
};

export function useTranslation(lang) {
    return translations[lang] || translations.fr;
}